/**
 * Sớ (Thanh Tịnh Pháp — Sớ / Ngôi Nhà Nhỏ) route family — Plans 7.2 decomposition.
 * All routes are direct children of _authenticated (authenticatedRoute).
 */
import { lazy } from "react";
import { createRoute } from "@tanstack/react-router";

import { authenticatedRoute } from "../__root.js";
import { withSuspense } from "../route-helpers.js";

// ── Lazy page imports ────────────────────────────────────────────────

const LhRecordsPage = lazy(() =>
  import("@/features/little-house").then((mod) => ({ default: mod.LhRecordsPage })),
);
const LhFraudQueuePage = lazy(() =>
  import("@/features/little-house").then((mod) => ({ default: mod.LhFraudQueuePage })),
);

// ── Routes ───────────────────────────────────────────────────────────

const lhRecordsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/so/danh-sach",
  component: withSuspense(LhRecordsPage),
});
const lhFraudQueueRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/so/gian-lan",
  component: withSuspense(LhFraudQueuePage),
});

export const soRoutes = [
  lhRecordsRoute,
  lhFraudQueueRoute,
];
